import { ConditionalFormattingConditionType } from '../store/schema/ConditionalFormattingConditionType';
import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';

const conditionalFormattingMailV2Conditions = new Set<ConditionalFormattingConditionType>([
    ConditionalFormattingConditionType.From,
    ConditionalFormattingConditionType.OnTheToOrCcLine,
    ConditionalFormattingConditionType.OnTheToLine,
    ConditionalFormattingConditionType.NotOnTheToLine,
    ConditionalFormattingConditionType.OnTheCcLine,
    ConditionalFormattingConditionType.SubjectIncludes,
    ConditionalFormattingConditionType.SenderAddressIncludes,
    // New conditions added in V2
    ConditionalFormattingConditionType.MentionsMe,
    ConditionalFormattingConditionType.ReadItems,
    ConditionalFormattingConditionType.UnreadItems,
    ConditionalFormattingConditionType.WithAttachments,
    ConditionalFormattingConditionType.WithoutAttachments,
    ConditionalFormattingConditionType.BetweenSize,
    ConditionalFormattingConditionType.GreaterThanSize,
    ConditionalFormattingConditionType.LowerThanSize,
    ConditionalFormattingConditionType.ImportanceHigh,
    ConditionalFormattingConditionType.ImportanceNormal,
    ConditionalFormattingConditionType.ImportanceLow,
    ConditionalFormattingConditionType.ImportanceCopilotPrioritized,
    ConditionalFormattingConditionType.Categories,
    ConditionalFormattingConditionType.FlaggedItems,
    ConditionalFormattingConditionType.UnflaggedItems,
    ConditionalFormattingConditionType.MarkedAsCompleted,
]);

const conditionalFormattingCalendarConditions = new Set<ConditionalFormattingConditionType>([
    ConditionalFormattingConditionType.OrganizedBy,
    ConditionalFormattingConditionType.SubjectIncludes,
    ConditionalFormattingConditionType.WithAttachments,
    ConditionalFormattingConditionType.WithoutAttachments,
]);

const isV2ConditionalFormattingMailCondition = (
    condition: ConditionalFormattingConditionType
): boolean => {
    return conditionalFormattingMailV2Conditions.has(condition);
};

const isConditionalFormattingCalendarCondition = (
    condition: ConditionalFormattingConditionType
): boolean => {
    return conditionalFormattingCalendarConditions.has(condition);
};

export function isConditionSupportedForScenario(
    condition: ConditionalFormattingConditionType,
    scenario: ConditionalFormattingScenario
): boolean {
    if (scenario === 'Mail') {
        return isV2ConditionalFormattingMailCondition(condition);
    }
    if (scenario === 'Calendar') {
        return isConditionalFormattingCalendarCondition(condition);
    }
    // For unknown scenarios return false.
    return false;
}

export function getConditionalFormattingConditionTypesForScenario(
    scenario: ConditionalFormattingScenario
): ReadonlySet<ConditionalFormattingConditionType> {
    if (scenario === 'Mail') {
        return conditionalFormattingMailV2Conditions;
    }
    if (scenario === 'Calendar') {
        return conditionalFormattingCalendarConditions;
    }
    return new Set();
}
